<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
// import CategoryCard from "@/components/cards/CategoryCard";
import appConfig from "@/app.config";
import api from "../../../api";

export default {
  page: {
    title: "ICB",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
    //  CategoryCard
  },
  data() {
    return {
      pcns: null,
      categoriesList: [],
      categories: [],
      networkCmsId: null,
      page: {
        title: "ICB",
        lastUpdated: "31 Dec 2020 15:00",
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
      stpCode: "",
    };
  },
  methods: {
    updateCurrentCategory(val) {
      this.$store.commit("updateCurrentCategory", val);
    },
    sleep(seconds) {
      return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
    },
    async getCategories() {
      let url = "/api/categories";
      let filter = {
        where: {
          or: [
            {
              name: "What is a PCN",
            },
            {
              name: "Banners",
            },
            {
              name: "Join the Practice",
            },
            {
              name: "Prescriptions",
            },
            {
              name: "Sick/Fit Notes",
            },
            {
              name: "Carer Information",
            },
            {
              name: "Patient Group",
            },
          ],
        },
      };
      filter = encodeURIComponent(JSON.stringify(filter));
      url = `${url}?filter=${filter}`;
      try {
        this.categories = (await api.get(url)).data;
      } catch (e) {
        console.log(e);
      }

      // if(this.currentCms && this.currentCms.id) {
      //   var url = '/api/cms/'+this.currentCms.id+'/categories'
      //   api.get(url)
      //   .then(response => {
      //     var objIndex = response.data.findIndex((obj => obj.name == 'Pages (Footer)'));
      //     if(objIndex != -1) {
      //       response.data[objIndex].name = "Info Pages"
      //     }
      //     this.categories = response.data;
      //   })
      //   .catch(e => {
      //     this.categories = []
      //     console.log(e)
      //   })
      // }
    },
    async getCurrentStpCode() {
      let url = "/api/stps";
      let filter = {
        include: [
          {
            relation: "ccgs",
            scope: {
              include: [
                {
                  relation: "pcns",
                  scope: {
                    where: {
                      id: this.currentPcn.id,
                    },
                  },
                },
              ],
            },
          },
        ],
      };
      filter = encodeURIComponent(JSON.stringify(filter));
      url = `${url}?filter=${filter}`;
      try {
        const { data } = await api.get(url);
        const stp = data.find((x) => x.ccgs.length && x.ccgs[0].pcns);
        this.stpCode = stp.code;
      } catch (e) {
        console.log(e);
      }
    },
    // getPcnWithRels() {
    //   if(this.currentPractice && Object.prototype.hasOwnProperty.call(this.currentPractice, 'pcnId')) {
    //     api.get(`/api/pcns/${this.currentPcn.id}/practice-data`)
    //     .then(response => {
    //       api.get(`/api/practice-data/${response.data.id}/cms`)
    //       .then(response2 => {
    //         this.networkCmsId = response2.data.id;
    //         api.get(`/api/cms/${response2.data.id}/categories`)
    //         .then(response3 => {
    //           this.categoriesList = response3.data;
    //         })
    //         .catch(e => {
    //           console.log(e)
    //         })
    //       })
    //       .catch(e => {
    //         console.log(e)
    //       })
    //     })
    //     .catch(e => {
    //       console.log(e)
    //     })
    //   }
    //   else {
    //     this.categoriesList = [];
    //   }
    // },
  },
  // watch: {
  //   currentPcn() {
  //     this.getPcnWithRels();
  //   }
  // },
  async mounted() {
    // await this.getPcnWithRels();
    console.log("====>", this.currentPcn);
    await this.getCategories();
    await this.getCurrentStpCode();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container pt-0">
      <div v-if="categories.length">
        <div class="font-size-20 font-weight-medium mt-4">
          Patient Communication
        </div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
          <div
            class="col-md-2"
            v-for="item in categories"
            v-bind:key="`${item.id}1`"
            :to="item.link"
            @click="updateCurrentCategory(item)"
            v-show="
              item.name == 'Banners' && item.additionalProp1.stpCode == stpCode
            "
          >
            <router-link
              :to="{
                name: 'Dynamic ICB Category Page',
                params: {
                  categoryId: item.id,
                  cmsId: item.cmsId,
                  categoryName: `${item.name
                    .replace(/ /g, '')
                    .toLowerCase()}icb`,
                },
              }"
              class="text-dark"
            >
              <div class="card align-items-center">
                <div
                  v-if="item.additionalProp1.beta"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #f28d00;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >BETA</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.coming_soon"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #333;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >COMING SOON</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.new"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #b60000;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >NEW</span
                  >
                </div>
                <div class="card-body p-0">
                  <div class="text-primary font-size-50">
                    <span v-if="item.additionalProp1.icon">
                      <img
                        v-if="item.additionalProp1.icon.endsWith('.svg')"
                        :src="
                          require(`@/assets/images/${item.additionalProp1.icon}`)
                        "
                      />
                      <i v-else :class="item.additionalProp1.icon"></i>
                    </span>
                  </div>
                </div>
                <div class="card-body p-0 pb-3 pt-2 text-center">
                  <p class="mx-auto text-uppercase m-0 font-weight-medium">
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <!-- <div class="font-size-20 font-weight-medium mt-4">
          Pages
      </div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
            <div class="col-md-2" v-for="item in categories" v-bind:key="`${item.id}1`"
            :to="item.link" @click="updateCurrentCategory(item)"
            v-show="item.name == 'Join the Practice' && item.additionalProp1.stpCode == stpCode
            || item.name == 'Prescriptions' && item.additionalProp1.stpCode == stpCode
            || item.name == 'Sick/Fit Notes' && item.additionalProp1.stpCode == stpCode
            || item.name == 'Carer Information' && item.additionalProp1.stpCode == stpCode
            || item.name == 'Patient Group' && item.additionalProp1.stpCode == stpCode
            ">
              <router-link :to="{name: 'Dynamic ICB Category Page', params: { categoryId: item.id, cmsId: item.cmsId, categoryName: `${item.name.replace(/ /g, '').toLowerCase()}icb` } }" class="text-dark">            
                  <div class="card align-items-center">
                      <div v-if="item.additionalProp1.beta" class="w-100 mt-3" style="margin-bottom: -2.5em; z-index: 1">
                        <span class="p-1 px-2 text-light" style="background-color: #f28d00; font-size: 11px; font-weight: 500">BETA</span>
                      </div>
                      <div v-if="item.additionalProp1.coming_soon" class="w-100 mt-3" style="margin-bottom: -2.5em; z-index: 1">
                        <span class="p-1 px-2 text-light" style="background-color: #333; font-size: 11px; font-weight: 500">COMING SOON</span>
                      </div>
                      <div v-if="item.additionalProp1.new" class="w-100 mt-3" style="margin-bottom: -2.5em; z-index: 1">
                        <span class="p-1 px-2 text-light" style="background-color: #b60000; font-size: 11px; font-weight: 500">NEW</span>
                      </div>
                      <div class="card-body p-0">
                          <div class="text-primary font-size-50">
                            <span v-if="item.additionalProp1.icon">
                              <img v-if="item.additionalProp1.icon.endsWith('.svg')" :src="require(`@/assets/images/${item.additionalProp1.icon}`)" />
                              <i v-else :class="item.additionalProp1.icon"></i>
                            </span>
                            </div>
                      </div>
                      <div class="card-body p-0 pb-3 pt-2 text-center">
                          <p class="mx-auto text-uppercase m-0 font-weight-medium">{{ item.name }}</p>
                      </div>
                  </div>
              </router-link>
            </div>
        </div> -->
        <div class="font-size-20 font-weight-medium mt-4">
          Primary Care Network
        </div>
        <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
          <div
            class="col-md-2"
            v-for="item in categories"
            v-bind:key="`${item.id}1`"
            :to="item.link"
            @click="updateCurrentCategory(item)"
            v-show="
              item.name == 'What is a PCN' &&
              item.additionalProp1.stpCode == stpCode
            "
          >
            <router-link
              :to="{
                name: 'Dynamic ICB Category Page',
                params: {
                  categoryId: item.id,
                  cmsId: item.cmsId,
                  categoryName: item.name.replace(/ /g, '').toLowerCase(),
                },
              }"
              class="text-dark"
            >
              <div class="card align-items-center">
                <div
                  v-if="item.additionalProp1.beta"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #f28d00;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >BETA</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.coming_soon"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #333;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >COMING SOON</span
                  >
                </div>
                <div
                  v-if="item.additionalProp1.new"
                  class="w-100 mt-3"
                  style="margin-bottom: -2.5em; z-index: 1"
                >
                  <span
                    class="p-1 px-2 text-light"
                    style="
                      background-color: #b60000;
                      font-size: 11px;
                      font-weight: 500;
                    "
                    >NEW</span
                  >
                </div>
                <div class="card-body p-0">
                  <div class="text-primary font-size-50">
                    <span v-if="item.additionalProp1.icon">
                      <img
                        v-if="item.additionalProp1.icon.endsWith('.svg')"
                        :src="
                          require(`@/assets/images/${item.additionalProp1.icon}`)
                        "
                      />
                      <i v-else :class="item.additionalProp1.icon"></i>
                    </span>
                  </div>
                </div>
                <div class="card-body p-0 pb-3 pt-2 text-center">
                  <p class="mx-auto text-uppercase m-0 font-weight-medium">
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
